import { render, staticRenderFns } from "./ProductionUnitsView.vue?vue&type=template&id=54192a78"
import script from "./ProductionUnitsView.vue?vue&type=script&lang=js"
export * from "./ProductionUnitsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports